const affiliatePattern = /\/(uite\/|\?vezi=)(\d+)/

export {affiliatePattern}